export default __webpack_public_path__ + "static/media/29t.4c021192.jpg";